<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="settings"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Sku Action</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content lines="none">
    <ion-list-header color="secondary">
        Define which actions to execute when this sku is purchased:
    </ion-list-header>
    
    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>
            
            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Sku</ion-label>
                <ion-input data-test="sku" color="secondary" readonly type="text" name="sku" #sku="ngModel"
                        [(ngModel)]="vm.sku" id="sku">
                </ion-input>
            </ion-item>
            
            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Description</ion-label>
                <ion-input data-test="description" color="secondary" readonly type="text" name="description" #description="ngModel"
                        [(ngModel)]="vm.description" id="description">
                </ion-input>
        
            </ion-item>

            <ion-item data-test="typeButton" id="typeButton" (click)="onTypeClick()">
                <ion-label class="ion-text-wrap" position="stacked">Type</ion-label>
                <ion-input data-test="type" color="secondary" type="text" name="type" #type="ngModel"
                        required [(ngModel)]="vm.type" id="type" data-specid="type">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label ion-text-wrap position="stacked">Increase Expiration Days</ion-label>
                <ion-input data-test="expirationDays" id="expirationDays" type="number" name="expirationDays" 
                        [(ngModel)]="vm.increaseExpirationDays"
                    autoFocus="true">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label ion-text-wrap position="stacked">Increase Expiration Months</ion-label>
                <ion-input data-test="expirationMonths" id="expirationMonths" type="number" name="expirationMonths" 
                        [(ngModel)]="vm.increaseExpirationMonths">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label ion-text-wrap position="stacked">Increase Expiration Years</ion-label>
                <ion-input data-test="expirationYears" id="expirationYears" type="number" name="expirationYears" 
                        [(ngModel)]="vm.increaseExpirationYears">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label ion-text-wrap position="stacked">Increase Premium Support Months</ion-label>
                <ion-input data-test="premiumSupportMonths" id="premiumSupportMonths" type="number" name="premiumSupportMonths" 
                        [(ngModel)]="vm.increasePremiumSupportMonths">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label ion-text-wrap position="stacked">Increase Premium Support Years</ion-label>
                <ion-input data-test="premiumSupportYears" id="premiumSupportYears" type="number" name="premiumSupportYears" 
                        [(ngModel)]="vm.increasePremiumSupportYears">
                </ion-input>
            </ion-item>
            
            <ion-item>
                <ion-label ion-text-wrap position="stacked">Increase Web Hosting Months</ion-label>
                <ion-input data-test="webHostingMonths" id="webHostingMonths" type="number" name="webHostingMonths" 
                        [(ngModel)]="vm.increaseWebHostingMonths">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label ion-text-wrap position="stacked">Increase Web Hosting Years</ion-label>
                <ion-input data-test="webHostingYears" id="webHostingYears" type="number" name="webHostingYears" 
                        [(ngModel)]="vm.increaseWebHostingYears">
                </ion-input>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Update Package Details</span><br />
                    <span class="line2">{{updatePackageDetailsText(vm.updatePackageDetails)}}</span>
                </ion-label>
                <ion-toggle data-test="updatePackageDetails" id="packageName" [(ngModel)]="vm.updatePackageDetails" name="packageName"></ion-toggle>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Update Credits</span><br />
                    <span class="line2">{{updateCreditsText(vm.updateCredits)}}</span>
                </ion-label>
                <ion-toggle data-test="updateCredits" id="updateCredits" [(ngModel)]="vm.updateCredits" name="updateCredits"></ion-toggle>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Update Activation Info</span><br />
                    <span class="line2">{{updateActivationInfo(vm.updateActivationInfo)}}</span>
                </ion-label>
                <ion-toggle data-test="updateActivationInfo" id="updateActivation" [(ngModel)]="vm.updateActivationInfo" name="updateActivation"></ion-toggle>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Send Complete Order Email To Support</span><br />
                    <span class="line2">{{sendEmailText(vm.sendCompleteOrderEmail)}}</span>
                </ion-label>
                <ion-toggle data-test="sendCompleteOrderEmail" id="sendEmail" [(ngModel)]="vm.sendCompleteOrderEmail" name="sendEmail"></ion-toggle>
            </ion-item>
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="saveButton" color="secondary" expand="full" (click)="onSaveClick(f)">Save</ion-button>
    </ion-toolbar>
</ion-footer>
